import rct from '../Images/rct-logo.jpg'
import pyt from '../Images/pyt-logo.jpg'
import mern from '../Images/mern-logo.jpg'
import machine from '../Images/machine.png'


const ProjectCardData = [
    {
        imgsrc: rct,
        title: "React Based Weather Application",
        text: "It delivers real-time weather updates with a user-friendly interface, leveraging React's interactivity and responsiveness.",
        view: "https://github.com/bsharanya-25/react-weather-app",
        source: "https://github.com/bsharanya-25/react-weather-app",

    },
    {
        imgsrc: mern,
        title: " Place2Pick: An E-commerce Application",
        text: "An E-commerce site with robust security, seamless navigation, and dynamic display using MERN Stack",
        view: "https://github.com/bsharanya-25/Place2Pick",
        source: "https://github.com/bsharanya-25/Place2Pick",

    },
    {
        imgsrc: rct,
        title: "Leetcode tree Visualizer",
        text: "Simplify binary tree problem-solving with intuitive visual construction.",
        view: "https://github.com/bsharanya-25/Leetcode-Tree-visualizer",
        source: "https://github.com/bsharanya-25/Leetcode-Tree-visualizer",

    },
    {
        imgsrc: machine,
        title: "Air Canvas Virtual pen model using Machine learning",
        text: "An interactive paint application that allows you to draw on a canvas using hand gestures captured by your webcam.",
        view: "https://github.com/bsharanya-25/Leetcode-Tree-visualizer",
        source: "https://github.com/bsharanya-25/Leetcode-Tree-visualizer",

    },
    {
        imgsrc: pyt,
        title: "AI Chatbot: AI companion with OpenAI technology",
        text: "AI chatbot, seamlessly merging cutting-edge OpenAI technology with intuitive interactions, offering users a personalized & insightful experience.",
        view: "https://github.com/bsharanya-25/AI-ChatBot",
        source: "https://github.com/bsharanya-25/AI-ChatBot",

    },
]


export default ProjectCardData;